<template>
  <p class="italic text-gray-500">{{ $t('common.hidden') }}</p>
</template>
